export default function Row({ tag: Tag = "article", className = "", children, ...props }) {
  return (
    <Tag {...props} className={`${className} element _row`}>
      {children}
    </Tag>
  );
}
